import css from 'styled-jsx/css'

import { colors, sizes } from '../../../theme'


export default css`
section.features {
  display: flex;
  align-items: center;
  flex-direction: column;
}

section.features :global(.cloud) {
  position: absolute;
  right: -5rem;
  bottom: -5rem;
  user-select: none;
}

section.features :global(.inner) {
  display: flex;
  max-width: ${sizes.body.desktop.maxWidth};
  width: 100%;
  position: relative;
}

section.features :global(.features) {
  background-color: ${colors.midnightExpress};
  max-width: ${sizes.body.tablet.maxWidth};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8rem;
  width: 100%;
  position: relative;
  padding-top: 3rem;
  padding-bottom: 5rem;
}

section.features :global(.text) {
  text-align: left;
}

section.features :global(.accordion) {
  padding: 2rem 2rem 0 2rem;
  display: none;
}

section.features :global(.accordion .panel .content) {
  color: ${colors.pureWhite};
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  section.features :global(.accordion) {
    display: block;
  }

  section.features .features {
    display: none;
  }

  section.features :global(.inner) {
    height: auto;
  }

  section.features :global(.features) {
    // padding-top: 3rem;
    // padding-bottom: 3rem;
  }

  section.features {
    // padding-left: 3rem;
    // padding-right: 3rem;
  }
}
`
